




































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import {outgoingInvoiceApi, stCustomerApi} from '@/services/st-api';
import {
  CustomerFilter, OutgoingInvoiceEditModel, OutgoingInvoiceFilter,
  OutgoingInvoiceTimeEntryModel,
  StSelectListItem,
  TimeEntryFilter
} from '@/services/api/nswag/stapiclient_generated';
import {DelayLoading} from '@/utlitities/delay-loading';

@Component({
  components: {
  },
})
export default class OutgoingInvoiceCustomer extends Vue {
  customers: StSelectListItem[] =[];
  @Prop() value!: number;
  @Prop() isSavedInvoice!: boolean;

  overwriteChangedInvoice: boolean = false;

  get showChangeWarning(){
    return this.isSavedInvoice && !this.overwriteChangedInvoice;
  }

  loading=true;

  async mounted(){
    try {
      this.customers = (await stCustomerApi.getSelectList(CustomerFilter.fromJS({})));
    } finally {
      this.loading = false;
    }
  }

  get customerId(){
    return this.value;
  }

  set customerId(val: number){
    this.$emit('input', val);
  }

}
